import { Provider } from '@angular/core';
import { ProductsService } from 'shared-data-access';
import { HOST_ENV_DATA } from '@allianz/taly-common/module-integration';
import { environment } from '../../../environments/environment';

export const journeyHostEnvDataProvider: Provider = {
  provide: HOST_ENV_DATA,
  useFactory: (productsService: ProductsService): Record<string, unknown> => {
    return {
      ...environment,
      BFF_BASE_URL: productsService.selectedProduct.salesServiceUrl,
    };
  },
  deps: [ProductsService],
};
